import React, { Component } from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import '../../style/generic.css';
import '../../style/hero.css';
import ellipse from '../../images/Ellipse6.png';
import heroImg from '../../images/heroImg.png';
import ReactPlayer from "react-player";
import * as Constanti from '../../Utils/constants.js';
import axios from "axios";
import { withRouter } from "../hooks/navigation.js";
import { motion, AnimatePresence } from 'framer-motion';
import closeMenu from '../../images/mingcute_close-fill.png';
import frecciaSelect from '../../images/weui_arrow-filled.png';

import CardHomeMobile from "../cards/cardHomeMobile.js";


class HeroSection extends Component{
constructor(props){
    
    super(props);
      this.handleOpenPlayer = this.handleOpenPlayer.bind(this);
      this.state = {
        isOpen: false,
      isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false
      };
      this.handleResize = this.handleResize.bind(this);
   
}
  componentDidMount() {
window.addEventListener('resize', this.handleResize);
this.handleResize();
}
componentWillUnmount() {
window.removeEventListener('resize', this.handleResize);
}

handleResize() {
const isMobile = window.innerWidth <= 768;
if (isMobile !== this.state.isMobile) {
this.setState({ isMobile });
}
}
 
getYouTubeVideoId(url) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}
 
 handleOpenPlayer = () => {
    if (this.props.isDiretta) {
      const videoId = this.getYouTubeVideoId(this.props.diretta.linkDiretta);
      this.props.onShowVideo(videoId);
    } else {
      this.props.navigate(`/video/${this.props.diretta.id}`);
    }
  };

   togglePopup = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  closePopup = () => {
    this.setState({ isOpen: false });
  };
 
  render(){
      const { diretta,isDiretta,categorie} = this.props;
    const { isMobile,isOpen} = this.state;
    return (
    <div>
    {!isMobile && diretta != null &&
   <section className="heroSection home flex horizontal">
  <div>
    <div className="hero-img">
      <img
        src={
          isDiretta
            ? Constanti.url_img_new + diretta.thumbnail
            : Constanti.url_img_new + diretta.thumbnail
        }
        alt=""
        className="img-hero"
      />
    </div>

    <div className="hero-left"></div>

    <div className="hero-video-info  height-100">
      <div className="container textWhite height-100">
        {/* --- ANIMAZIONE HERO --- */}
        <motion.div
          className="flex vertical align-start justify-end height-100"
          initial="hidden"
          animate="visible"
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.25,
                delayChildren: 0, // leggermente prima dell’header
              },
            },
          }}
        >
          {/* Box LIVE */}
          {isDiretta && (
            <motion.div
              className="liveBox flex horizontal justify-center align-center padding-bottom-32"
              variants={{
                hidden: { opacity: 0, y: 60 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
              }}
            >
              <img
                src={ellipse}
                width={6}
                height={6}
                alt=""
                className="imgLive"
              />
              <span>Live</span>
            </motion.div>
          )}

          {/* Titolo */}
          <motion.div
            className="HeroTitle padding-bottom-32 padding-top-32"
            variants={{
              hidden: { opacity: 0, y: 60 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.7, delay: 0.1 },
              },
            }}
          >
            {isDiretta ? diretta.titolo_diretta : diretta.title}
          </motion.div>

          {/* Bottone */}
          <motion.div
            className="buttonHero"
            variants={{
              hidden: { opacity: 0, y: 60 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 0.7, delay: 0.2 },
              },
            }}
          >
            <button className="buttonVideo cursor-pointer" onClick={this.handleOpenPlayer}>
              Vai al video
            </button>
          </motion.div>
        </motion.div>
      </div>
    </div>
  </div>
</section>
    }
    {isMobile &&
    <div className="heroSectionMobile">
        <div className="flex vertical gap-8" > 
        <div className="flex horizontal selectCategorie" onClick={this.togglePopup}>
        <div>Categorie</div>
        <img src={frecciaSelect}  alt="" class="frecciaMobile"/>
        </div>
        <div onClick={this.handleOpenPlayer}>
        {diretta != null &&
        <CardHomeMobile title={isDiretta ? diretta != null ? diretta.titolo_diretta : diretta.title : ""} thumbnail={isDiretta ? Constanti.url_img_new+diretta.thumbnail: Constanti.url_img_new+diretta.thumbnail} isDiretta={isDiretta}></CardHomeMobile>
        }
        </div>
      
        
      
        </div>
    </div>
    }
     <AnimatePresence>
          {isOpen && (
            <motion.div
              className="fullscreen-popup mobileCategory"
              initial={{ y: '-100%' }}
              animate={{ y: 0 }}
              exit={{ y: '-100%' }}
              transition={{ duration: 0.4, ease: 'easeInOut' }}
            >
               <div className="close-button" onClick={this.closePopup}>
                <img src={closeMenu}></img>
               </div>
              <div className="popup-content">
                {categorie != null && categorie?.map(el => (
              <Link className="block-link" key={'men'+el.id} to={"/categoria/"+el.id} onClick={this.closePopup}>
                  <span className="link-menu">{el.description}</span>
              </Link>
                ))}
              </div>
            </motion.div>
          )}
          </AnimatePresence>
</div>
    )
}
}

export default withRouter(HeroSection)